import { gql } from '@apollo/client';
import { Commande } from '../../fragments/commande/commande.fragments';

const QUERY_COMMANDE_DETAILS = gql`
  query CommandeDetails($id: ID!) {
    commande(id: $id) {
      data {
        id
        attributes {
          ...DetailsCommande
        }
      }
    }
  }
  ${Commande.fragments.detailsCommande}
`;

export default QUERY_COMMANDE_DETAILS;
